const en = {
  lang: "en",
  home: "HOME",
  welcomeText:
    "Hello, I'm luka rostomashvili providing services Lawyer, spanish learning, visa, driver licence, translate",
  services: "SERVICES",
  lawyer: "LAWYER",
  academy: "LUKA ACADEMY",
  visa: "VISA SERVICE",
  driver: "DRIVER LICENSE",
  translate: "TRANSLATE",
  aboutMe: "ABOUT ME",
  aboutMeText:
    "i am lawyer, With a background in both Spanish education and digital marketing, I offer a unique skill set that blends language mastery with marketing savvy. Whether teaching students or driving online campaigns, I bring passion, creativity, and results-oriented thinking to every project.",
  education: "EDUCATION",
  educationText:
    "i have received education in barcelona university and also alicante university",
  achievement: "ACHIEVEMENTS",
  contact: "CONTACT",
  recomendations: "RECOMENDATIONS",
  recomendation_one: "thank you luka for support, you are good man",
  recomendation_two:
    "thanks luka for support and lot of useful information he is really profesional. i recomend luka",
};

export default en;
